// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"237":"pages","409":"my","945":"dashboard"}[chunkId] || chunkId) + "." + {"237":"6f4dedb0","409":"fcd3d746","779":"72a479d5","945":"8346b124"}[chunkId] + ".css";
};